var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconStorygameLandscape = function SvgIconStorygameLandscape(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.214 2.926a2.75 2.75 0 0 0-3.889 0l-9.9 9.9a2.75 2.75 0 0 0 0 3.889l5.36 5.359a2.75 2.75 0 0 0 3.889 0l9.9-9.9a2.75 2.75 0 0 0 0-3.889l-5.36-5.359Zm-2.828 1.06a1.25 1.25 0 0 1 1.767 0l5.36 5.36a1.25 1.25 0 0 1 0 1.768l-9.9 9.899a1.25 1.25 0 0 1-1.768 0l-5.359-5.36a1.25 1.25 0 0 1 0-1.767l9.9-9.9Zm-5.63 12.756a1 1 0 1 0 1.415-1.414 1 1 0 0 0-1.414 1.415Z",
    fill: "#000",
    fillOpacity: 0.9
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 9c0-3.093 2.686-5.6 6-5.6L7 2M22 15.5c0 3.093-2.686 5.6-6 5.6l1.5 1.4",
    stroke: "#1A1A1A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgIconStorygameLandscape;